export enum ButtonColorEnum {
    WHITE = 'white',
    PINK = 'pink',
    PURPLE = 'purple',
    GREEN = 'green',
    GREY = 'grey',
    DARK_GREEN = 'dark_green'
}
  